export default {
  path: "/main/analysis/overview",
  name: "Overview",
  component: () => import("@/views/main/Analysis/overview.vue"),
  children: []
};
